(function () {
  var container = document.getElementById('Details-menu-drawer-container');
  if (!container) return;

  container.addEventListener('toggle', function () {
    if (!container.open) return;
    container.querySelectorAll('[id^="Details-menu-drawer-menu-item-"]').forEach(function (details) {
      if (!details.open) details.setAttribute('open', '');
    });
  });
})();
